/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ProductRemainderModel { 
    storeId?: number;
    forSale?: boolean;
    balance?: number;
    reservedPickUp?: number | null;
    reservedDelivery?: number | null;
    reserved?: number;
    limit?: number;
    plan?: number;
    cart?: number;
    remainder?: number;
}

